module.exports = __webpack_public_path__ + "img/flightdecklitelogosimple.82ccaadd.svg";